module.exports = __webpack_public_path__ + "static/media/iconEdit3.8959fdcf.svg";